import {
  dummyNft1,
  dummyNft2,
  dummyNft3,
  dummyNft4,
  dummyNft5,
} from "../assets";

export const myNFTs = [
  {
    id: 1,
    name: "Doodle",
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: false,
    remainingDuration: "15D/8H/45M",
    status: "Available",
    tokenId: "12376",
    contractName: "Doodles",

    image: dummyNft1,
  },
  {
    id: 2,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft2,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: false,
    remainingDuration: "15D/8H/45M",
    status: "Available",
  },
  {
    id: 3,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft3,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: true,
    remainingDuration: "15D/8H/45M",
    status: "Available",
  },
  {
    id: 4,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft4,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: false,
    remainingDuration: "15D/8H/45M",
    status: "Available",
  },
  {
    id: 5,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft5,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: true,
    remainingDuration: "15D/8H/45M",
    status: "Available",
  },

  {
    id: 6,
    name: "Doodle",
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: false,
    remainingDuration: "15D/8H/45M",
    status: "On Loan",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft1,
  },
  {
    id: 7,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft2,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: false,
    remainingDuration: "15D/8H/45M",
    status: "On Loan",
  },
  {
    id: 8,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft3,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: true,
    remainingDuration: "15D/8H/45M",
    status: "On Loan",
  },
  {
    id: 9,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft4,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: false,
    remainingDuration: "15D/8H/45M",
    status: "On Loan",
  },
  {
    id: 10,
    name: "Doodle",
    tokenId: "12376",
    contractName: "Doodles",
    image: dummyNft5,
    nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
    selected: true,
    remainingDuration: "15D/8H/45M",
    status: "On Loan",
  },
];
